import cx from 'classnames';
import type { VoidFunctionComponent } from 'react';

import { isOSSupported, parseLinuxPackage } from '../../../../../../../shared/linux';

import styles from './StateContextPanel.module.less';

type Props = {
    revision: string;
};

const UnknownStatePanel: VoidFunctionComponent<Props> = ({ revision }) => {
  const linuxPackage = parseLinuxPackage(revision);

  if (typeof linuxPackage !== 'string' && !isOSSupported(linuxPackage.distro)) {
    return (
      <div className={cx(styles.stateContextPanel, styles.buildState)}>
        FOSSA was unable to analyze this dependency because '{ linuxPackage.distro }' is an <a href = "https://docs.fossa.com/docs/container-scanning#supported-base-containers">unsupported container OS</a >.
      </div>
    );
  }

  return (
    <div className={cx(styles.stateContextPanel, styles.buildState)}>
      FOSSA was unable to analyze this dependency.
      If it is behind a private registry or auth you may need to configure FOSSA&apos;s access,
      then rebuild this dependency.
    </div>
  );
};

export default UnknownStatePanel;
